<template>
  <div>
    <baseFrame
      submitText="提交"
      clearText=""
      @submit="submit"
      @cancel="handleToPlanList"
      :submitLoading="submitLoading"
      :showCtrls="true"
      :infosArr="infosArr"
      :id="stocktakingPlan.serialNumber"
      idText="盘点单号">
      <div slot="content">
        <lk-card title="盘点损溢信息">
          <lk-form>
            <lk-row>
              <lk-col>
                <lk-form-item>
                  <div class="requireStocktakingAdjust">
                    <lk-table
                      border
                      :columns="columns"
                      :data="tableData">
                    </lk-table>
                  </div>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </baseFrame>
  </div>
</template>
<script>
import baseFrame from '../../components/frame/BaseFrame.vue';
import inventory from '../../services/inventory';
import sharedDara from '../../libs/sharedDara';
import utils from '../../libs/utils';

export default {
  name: 'stocktakingProfitAndLossAdd',
  components: {
    baseFrame,
  },
  data() {
    return {
      submitLoading: false,
      infosArr: [],
      adjustTotalCount: 0,
      adjustTotalPrice: 0,
      stocktakingPlan: {},
      statusMap: new Map([
        [1, '启用'],
        [2, '禁用'],
      ]),
      boolsMap: new Map([
        [1, '是'],
        [2, '否'],
      ]),
      applyReason: '',
      columns: [
        { title: '序号', type: 'index', width: 80 },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 110 },
        { title: '商品名称', key: 'goodsName', minWidth: 110 },
        { title: '系统冻结数量', key: 'breakageFrozenAmount', minWidth: 110 },
        { title: '手动冻结数量', key: 'manualFrozenNum', minWidth: 110 },
        { title: '可销售数量', key: 'inventoryCount', minWidth: 110 },
        { title: '在库数量', key: 'inInventoryCount', minWidth: 110 },
        { title: '规格', key: 'specifications', minWidth: 110 },
        { title: '剂型', key: 'dosageForm', minWidth: 110 },
        { title: '单位', key: 'drugMiniPackageUnit', minWidth: 110 },
        { title: '批号', key: 'goodsBatchNumber', minWidth: 110 },
        {
          title: '商品状态',
          key: 'goodsStoreStatus',
          minWidth: 110,
		      render: (h, { row }) => h('label', this.statusMap.get(row.goodsStoreStatus)),
        },
        { title: '仓库', key: 'warehouseName', minWidth: 110 },
        { title: '通用名称', key: 'approvedName', minWidth: 110 },
        {
          title: '实盘库存', key: 'realCount', minWidth: 130,
        },
        { title: '未处理损溢数量', key: 'noDealNum', minWidth: 110 },
        {
          title: '本次处理损溢数量',
          key: 'adjustCount',
          minWidth: 110,
          fixed: 'right',
          render: (h, { row, index }) => h('lk-input-number', {
            props: {
              value: row.adjustCount,
              min: -1000000000,
              max: 1000000000,
              precision: 2,
              activeChange: false,
              placeholder: '请输入',
            },
            on: {
              'on-change': (value) => {
                row.adjustCount = value;
                setTimeout(() => {
                  this.tableData[index].adjustCount = value;
                });
              },
            },
          }),
        },
        {
          title: '本次调整批次',
          key: 'adjustBatchSeqId',
          minWidth: 110,
          fixed: 'right',
          render: (h, { row, index }) => {
            const options = row.inventoryInfoList.map(item => h('lk-option', {
              props: {
                value: item.id
              }
            }, `批次  ${item.goodsBatchSeq} 可销售  ${item.goodsStockNum}`));
            return h('lk-select', {
              props: {
                value: row.adjustBatchSeqId,
                transfer: true,
              },
              on: {
                'on-change': (value) => {
                  let item = row.inventoryInfoList.find(item => item.id === value);
                  if (item) {
                    row.adjustBatchSeq = item.goodsBatchSeq;
                    row.adjustBatchSeqId = value;
                    item = null;
                    row.inventoryId = value;
                    setTimeout(() => {
                      this.tableData[index].adjustBatchSeq = row.adjustBatchSeq;
                      this.tableData[index].adjustBatchSeqId = row.adjustBatchSeqId;
                      this.tableData[index].inventoryId = row.inventoryId;
                    });
                  }
                },
              },
            },
            options);
          }
        },
        {
          title: '是否调整库存',
          key: 'changeInventory',
          minWidth: 110,
          fixed: 'right',
          render: (h, { row, index }) => {
            const options = sharedDara.booleanList.map(item => h('lk-option', {
              props: {
                value: item.id
              }
            }, item.name));
            return h('lk-select', {
              props: {
                value: row.changeInventory,
                transfer: true,
              },
              on: {
                'on-change': (value) => {
                  row.changeInventory = value;
                  setTimeout(() => {
                    this.tableData[index].changeInventory = row.changeInventory;
                  });
                },
              },
            },
            options);
          }
        },
        {
          title: '损溢原因',
          key: 'adjustReason',
          minWidth: 110,
          fixed: 'right',
          render: (h, { row, index }) => h('lk-input', {
            props: {
              clearable: true,
              value: row.adjustReason,
              maxlength: 50,
            },
            on: {
              'on-blur': (e) => {
                row.adjustReason = e.target.value;
                setTimeout(() => {
                  this.tableData[index].adjustReason = row.adjustReason;
                });
              },
            },
          }),
        },
        {
          title: '操作',
          fixed: 'right',
          minWidth: 110,
          render: (h, { row, index }) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.tableData.push(row);
                }
              }
            }, '复制'),
            h('lk-button', {
              props: {
                type: 'text',
                disabled: this.tableData.length === 1
              },
              on: {
                click: () => {
                  this.tableData.splice(index, 1);
                }
              }
            }, '删除')
          ])
        },
      ],
      tableData: [],
    };
  },
  computed: {},
  methods: {
    getData() {
      inventory.editStocktakingProfitAndLoss({ stocktakingPlanId: Number.parseInt(this.$route.params.id, 10) })
        .then((res) => {
          if (res.data.status === 200) {
            const { stocktakingPlan, stocktakingRecords } = res.data.data;
            let adjustTotalCount = 0;
            let adjustTotalPrice = 0;
            stocktakingRecords.forEach((item) => {
              item.stocktakingRecordId = item.id;
              item.goodsStoreStatusStr = this.statusMap.get(item.goodsStoreStatus);
              item.adjustReason = '';
              item.adjustTotalPrice = utils.addPlusPrefix(utils.toFixed2(item.priceBeforeTax * item.adjustCount));
              // 损溢合计
              adjustTotalCount += Number(item.adjustCount);
              adjustTotalPrice += Number(item.adjustTotalPrice);
            });

            this.setInfoArr(stocktakingPlan);
            this.stocktakingPlan = stocktakingPlan;
            this.tableData = stocktakingRecords;
            this.adjustTotalCount = utils.addPlusPrefix(adjustTotalCount.toFixed(2));
            this.adjustTotalPrice = utils.addPlusPrefix(utils.toFixed2(adjustTotalPrice));
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    setInfoArr(stocktakingPlan) {
      if (!stocktakingPlan) {
        return;
      }
      stocktakingPlan.hasZeroStr = this.boolsMap.get(stocktakingPlan.hasZero);
      stocktakingPlan.createTime = utils.exchangeTime(stocktakingPlan.createTime);
      stocktakingPlan.operatorTime = utils.exchangeTimeToSecond(stocktakingPlan.operatorTime);
      stocktakingPlan.operatorType = sharedDara.operatorTypeList[stocktakingPlan.operatorType - 1].name;
      stocktakingPlan.operatorPattern = sharedDara.operatorPatternsList[stocktakingPlan.operatorPattern - 1].name;
      stocktakingPlan.checkUserName = `${stocktakingPlan.firstOperatorName}-${stocktakingPlan.secondOperatorName}`;
      stocktakingPlan.checkTime = `${utils.exchangeTimeToSecond(stocktakingPlan.firstOperatorTime)}-${utils.exchangeTimeToSecond(stocktakingPlan.secondOperatorTime)}`;
      if (!stocktakingPlan.warehouseNames) {
        stocktakingPlan.warehouseNames = '全部';
      }
      const infosArr = [
        {
          name: '盘点计划名称:',
          value: stocktakingPlan.name,
        },
        {
          name: '盘点类型:',
          value: stocktakingPlan.operatorType,
        },
        {
          name: '盘点方式:',
          value: stocktakingPlan.operatorPattern,
        },
        {
          name: '是否含0在库数量商品:',
          value: stocktakingPlan.hasZeroStr,
        },
        {
          name: '盘点仓库:',
          value: stocktakingPlan.warehouseNames,
        },
        {
          name: '创建人员:',
          value: stocktakingPlan.createUserName,
        },
        {
          name: '创建时间:',
          value: stocktakingPlan.createTime,
        },
        {
          name: '盘点人员:',
          value: stocktakingPlan.operatorName,
        },
        {
          name: '盘点时间:',
          value: stocktakingPlan.operatorTime,
        },
        {
          name: '录入人员:',
          value: stocktakingPlan.checkUserName,
        },
        {
          name: '录入时间:',
          value: stocktakingPlan.checkTime,
        },
      ];
      this.infosArr = infosArr;
    },
    submit() {
      let errorMsg = '';
      const len = this.tableData.length;
      if (len === 0) {
        errorMsg = '请选择商品调整信息';
      }

      for (let i = 0; i < len; i++) {
        const item = this.tableData[i];
        if (item.adjustReason == '' || item.changeInventory == '' || item.adjustBatchSeq == '' || item.adjustCount === '') {
          errorMsg = '请先填写完信息';
          break;
        }
        //校验单个商品的未处理损溢数量和本次处理损溢数量，本次处理损溢量不可大于商品的未处理损溢量
        if (item.noDealNum < 0 && item.adjustCount > 0) {
          errorMsg = '未处理损溢数量为负数时，本次处理损溢数量需为负数';
          break;
        }
        if (item.noDealNum > 0 && item.adjustCount < 0) {
          errorMsg = '未处理损溢数量为正数时，本次处理损溢数量需为正数';
          break;
        }
        if (item.noDealNum > 0 && item.noDealNum < item.adjustCount ) {
          errorMsg = '单个商品的本次处理损溢量不可大于未处理损溢量';
          break;
        }
        if (item.noDealNum < 0 && item.noDealNum > item.adjustCount ) {
          errorMsg = '单个商品的本次处理损溢量不可大于未处理损溢量';
          break;
        }
        if (item.adjustCount === 0) {
          errorMsg = '本次处理损溢数量不可为0';
          break;
        }
        if (item.noDealNum < 0 && item.adjustCount > item.inventoryCount) {
          errorMsg = '本次处理损溢数量不可大于可销售数量';
          break;
        }
      }

      if (errorMsg) {
        this.$Message.error(errorMsg);
        return;
      }

      const params = {};
      params.stocktakingProfitAndLoss = {
        stocktakingPlanId: this.stocktakingPlan.id,
        applyReason: this.applyReason,
      };
      params.stocktakingProfitAndLossAdjusts = this.tableData;

      this.submitLoading = true;
      inventory.submitStocktakingProfitAndLossResult(params).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('提交成功');
          this.handleToPlanList();
        } else {
          this.$Message.error(res.data.error);
        }
        this.submitLoading = false;
      }).catch((err) => {
        this.submitLoading = false;
        utils.handleError(err);
      });
    },
    handleToPlanList() {
      this.$router.push({
        name: 'stocktakingPlan',
      });
    },
  },
  created() {
    this.getData();
  },
};
</script>
<style lang="less" scoped>
</style>
